var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({width: ((_vm.width/10) + "rem"), height: ((_vm.height/10) + "rem")})})}
var staticRenderFns = []

export { render, staticRenderFns }